<template>
  <div class="hris-page">
    <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">Online Forms</span>
      <h1 class="hris-page-title">Overtime</h1>
      <p class="hris-page-subtitle">Submit an overtime request for regular duty or restday schedules.</p>
    </div>

    <div class="hris-form-narrow">
    <div class="hris-form-banner hris-form-banner-warning">
      Overtime should be min. of two(2) hours.
    </div>

    <q-form>
      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Inclusive Date</h2>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <label class="hris-form-label">Overtime Start Date</label>
            <q-input v-model="otStartDate" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                  <q-popup-proxy ref="qOTSTDateProxy" transition-show="flip-down" transition-hide="flip-up">
                    <q-date v-model="form.selectedOTStartDate" @input="$refs.qOTSTDateProxy.hide()" today-btn color="green" minimal ></q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="hris-form-field">
            <label class="hris-form-label">Overtime End Date</label>
            <q-input v-model="otEndDate" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-calendar-alt" class="cursor-pointer">
                  <q-popup-proxy ref="qOTEDDateProxy" transition-show="flip-down" transition-hide="flip-up">
                    <q-date v-model="form.selectedOTEndDate" @input="$refs.qOTEDDateProxy.hide()" today-btn color="green" minimal />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </div>

      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Schedule Type</h2>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <q-radio class="full-width" v-model="form.scheduleType" val="Regular Duty" @input="setSchedType(form.scheduleType)" label="Regular Duty" color="green" />
          </div>
          <div class="hris-form-field">
            <q-radio class="full-width" v-model="form.scheduleType" val="Restday" @input="setSchedType(form.scheduleType)" label="Restday" color="green" />
          </div>
        </div>
      </div>

      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Inclusive Time</h2>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <label class="hris-form-label">Shift Schedule Time-In</label>
            <q-input :value="originalTimeIn" :disable="shiftTimeWorking" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-clock" class="cursor-pointer">
                  <q-popup-proxy transition-show="flip-down" transition-hide="flip-up">
                    <q-time v-model="form.shiftTimeIn" :minute-options="minuteOptions" landscape color="green" minimal>
                      <div class="row items-center justify-end q-gutter-xs">
                        <q-btn label="Cancel" color="green" style="width: 80px" flat v-close-popup />
                        <q-btn label="OK" color="green" style="width: 80px" flat @click="saveTime('shiftTimeIn', form.shiftTimeIn)" v-close-popup />
                      </div>
                    </q-time>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="hris-form-field">
            <label class="hris-form-label">Shift Schedule Time-Out</label>
            <q-input v-model="originalTimeOut" :disable="shiftTimeWorking" outlined dense color="green" readonly />
          </div>
        </div>
        <div class="hris-form-row">
          <div class="hris-form-field">
            <label class="hris-form-label">Overtime Start</label>
            <div v-show="form.scheduleType == 'Restday'">
              <q-input :value="overtimeStart" :disable="otWorking" outlined dense color="green" readonly>
                <template v-slot:append>
                  <q-icon name="fa fa-clock" class="cursor-pointer">
                    <q-popup-proxy transition-show="flip-down" transition-hide="flip-up">
                      <q-time v-model="form.otStart" :minute-options="minuteOptions" landscape color="green" minimal>
                        <div class="row items-center justify-end q-gutter-xs">
                          <q-btn label="Cancel" color="green" style="width: 80px" flat v-close-popup />
                          <q-btn label="OK" color="green" style="width: 80px" flat @click="saveTime('otStart', form.otStart)" v-close-popup />
                        </div>
                      </q-time>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div v-show="form.scheduleType != 'Restday'">
              <q-input :value="overtimeStart" :disable="otWorking" outlined dense color="green" readonly>
                <template v-slot:append>
                  <q-icon name="fa fa-clock" class="cursor-pointer">
                    <q-popup-proxy transition-show="flip-down" transition-hide="flip-up">
                      <q-time v-model="form.otStart" :minute-options="minuteOptions" landscape color="green" minimal>
                        <div class="row items-center justify-end q-gutter-xs">
                          <q-btn label="Cancel" color="green" style="width: 80px" flat v-close-popup />
                          <q-btn label="OK" color="green" style="width: 80px" flat @click="saveTime('otStart', form.otStart)" v-close-popup />
                        </div>
                      </q-time>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
          </div>
          <div class="hris-form-field">
            <label class="hris-form-label">Overtime End</label>
            <q-input :value="overtimeEnd" :disable="otWorking" outlined dense color="green" readonly>
              <template v-slot:append>
                <q-icon name="fa fa-clock" class="cursor-pointer">
                  <q-popup-proxy transition-show="flip-down" transition-hide="flip-up">
                    <q-time v-model="form.otEnd" :minute-options="minuteOptions" landscape color="green" minimal>
                      <div class="row items-center justify-end q-gutter-xs">
                        <q-btn label="Cancel" color="green" style="width: 80px" flat v-close-popup />
                        <q-btn label="OK" color="green" style="width: 80px" flat @click="saveTime('otEnd', form.otEnd)" v-close-popup />
                      </div>
                    </q-time>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </div>

      <div class="hris-form-section">
        <h2 class="hris-form-section-title">Reason</h2>
        <div class="hris-form-row">
          <div class="hris-form-field" style="flex-basis: 100%;">
            <q-input type="textarea" v-model="form.otReason" outlined dense color="green" maxlength="250" clearable bottom-slots counter hint="Max 250 characters" />
          </div>
        </div>
      </div>

      <div class="hris-form-actions">
        <q-btn unelevated class="hris-q-outline" @click="resetForm" label="Reset" style="min-width: 140px;" />
        <q-btn unelevated class="hris-q-primary" @click="submitApplication" :loading="loading" label="Submit" style="min-width: 140px;">
          <template v-slot:loading>
            <q-spinner color="green" class="on-left" />
            Sending...
          </template>
        </q-btn>
      </div>
    </q-form>
    </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { date } from 'quasar';

let today = Date.now();
const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

export default {
  name: 'Overtime',
  props: ['value'],
  data() {
    return {
      shiftHours: 0,
      loading: false,
      form: {
        selectedOTStartDate: '',
        selectedOTEndDate: '',
        scheduleType: '',
        shiftTimeIn: '',
        shiftTimeOut: '',
        otStart: '',
        otEnd: '',
        totalOTHours: '',
        otReason: ''
      },
      shiftTimeWorking: true,
      otWorking: true,
      originalTimeIn: 'Please select schedule type...',
      originalTimeOut: 'Please select schedule type...',
      overtimeStart: 'Please select schedule type...',
      overtimeEnd: 'Please select schedule type...',
      minuteOptions: [0, 30],
      otMinuteOption: [],
      msOTStart: 0,
      msOTEnd: 0
    }
  },
  methods: {
    setSchedType: function(schedType) {
      this.shiftHours = this.userData.shift_hours;
      if (schedType == 'Restday') {
        this.shiftTimeWorking = true;
        this.otWorking = false;
        this.originalTimeIn = 'Restday';
        this.originalTimeOut = 'Restday';
        this.form.shiftTimeIn = '00:00';
        this.form.shiftTimeOut = '00:00';
        this.overtimeStart = 'Please select a time...';
        this.overtimeEnd = 'Please select a time...';
        this.otMinuteOption = [0, 30];
      } else {
        this.shiftTimeWorking = false;
        this.otWorking = true;
        this.originalTimeIn = 'Please select a time...';
        this.originalTimeOut = 'Please select shift time-in...';
        this.overtimeStart = 'Please select shift time-in...';
        this.overtimeEnd = 'Please select shift time-in...';
      }
    },

    saveTime: function(type, timeSent) {
      var tempTime = timeSent.split(':');
      var newTime = date.buildDate({ hours: tempTime[0], minutes: tempTime[1] });

      switch (type) {
        case 'shiftTimeIn':
          var originalFormattedTimeIn = date.formatDate(newTime, 'hh:mm A');
          this.originalTimeIn = originalFormattedTimeIn;
          var originalTimeOutPlus = date.addToDate(newTime, { hours: this.shiftHours });
          var originalFormattedTimeOut = date.formatDate(originalTimeOutPlus, 'hh:mm A');
          var finalTimeOut = date.formatDate(originalTimeOutPlus, 'HH:mm');
          this.originalTimeOut = originalFormattedTimeOut;
          this.form.shiftTimeOut = finalTimeOut;
          this.otWorking = false;
          this.overtimeStart = originalFormattedTimeOut;
          this.form.otStart = finalTimeOut;
          var tempOTStart = finalTimeOut.split(':');
          var newOTStartTime = date.buildDate({ hours: tempOTStart[0], minutes: tempOTStart[1] });
          this.msOTStart = newOTStartTime;
          break;
        case 'otStart':
          var newFormattedOTStart = date.formatDate(newTime, 'hh:mm A');
          this.overtimeStart = newFormattedOTStart;
          // this.msOTStart = newTime;
          break;
        case 'otEnd':
          var newFormattedOTEnd = date.formatDate(newTime, 'hh:mm A');
          this.overtimeEnd = newFormattedOTEnd;
          // this.msOTEnd = newTime;
          break;
      }
    },

    submitApplication: function() {
      var otStartDateSelected = date.formatDate(this.form.selectedOTStartDate, 'YYYY-MM-DD');
      var otEndDateSelected = date.formatDate(this.form.selectedOTEndDate, 'YYYY-MM-DD');
      var concatOTStart = otStartDateSelected + ' ' + this.form.otStart;
      var concatOTEnd = otEndDateSelected + ' ' + this.form.otEnd;
      var otStartDateTime = new Date(concatOTStart);
      var otEndDateTime = new Date(concatOTEnd);
      var minDiff = date.getDateDiff(otEndDateTime, otStartDateTime, 'minutes');
      var otTotalHours = parseFloat(minDiff / 60);
      console.log(otTotalHours)
      this.form.selectedOTStartDate = otStartDateSelected;
      this.form.selectedOTEndDate = otEndDateSelected;
      this.form.totalOTHours = otTotalHours;

      if (this.form.selectedOTStartDate == undefined || this.form.selectedOTEndDate == undefined ||
        this.form.scheduleType == '' || this.form.shiftTimeIn == '' || this.form.shiftTimeOut == '' ||
        this.form.otStart == '' || this.form.otEnd == '' || this.form.otReason == '') {
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'Please fill-in all necessary details.'
        });
      } else if (otTotalHours < 2) {
        this.$q.notify({
          color: 'red-6',
          textColor: 'white',
          icon: 'fa fa-exclamation-circle',
          message: 'OT should be minimum of 2 hours.'
        });
      } else {
        this.loading = true;

        let formData = new FormData();
        formData.append('form_data', JSON.stringify(this.form));

        axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        }).post('/online-forms/applications/overtime', formData).then((res) => {
            if(res.data.status){
                setTimeout(() => {
                  this.loading = false;
                  this.$q.notify({
                    color: 'green-7',
                    textColor: 'white',
                    icon: 'fa fa-check',
                    message: res.data.message
                  });
                  this.resetForm();
                }, 1000);
            }else{
                setTimeout(() => {
                  this.loading = false;
                  this.$q.notify({
                    color: 'red-7',
                    textColor: 'white',
                    icon: 'fa fa-times',
                    message: res.data.message
                  });
                  this.resetForm();
                }, 1000);
            }

        });
      }
    },

    resetForm: function() {
      var self = this;
      Object.keys(this.form).forEach(function(key, index) {
        self.form[key] = '';
      });
      this.originalTimeIn = 'Please select schedule type...';
      this.originalTimeOut = 'Please select schedule type...';
      this.overtimeStart = 'Please select schedule type...';
      this.overtimeEnd = 'Please select schedule type...';
      this.shiftTimeWorking = true;
      this.otWorking = true;
      setTimeout(() => {
        scrollToTop();
      }, 200);
    }
  },
  computed: {
    otStartDate: function() {
      if (this.form.selectedOTStartDate == '') {
        return 'Please select a date...';
      } else {
        let d = new Date(this.form.selectedOTStartDate);
        return date.formatDate(d, 'dddd, MMMM DD, YYYY');
      }
    },

    otEndDate: function() {
      if (this.form.selectedOTEndDate == '') {
        return 'Please select a date...';
      } else {
        let d = new Date(this.form.selectedOTEndDate);
        return date.formatDate(d, 'dddd, MMMM DD, YYYY');
      }
    }
  }
}
</script>
<style scoped>
</style>
